import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../config/firebase';
import { collection, getDocs } from 'firebase/firestore';
import '../styles/attendance.css';

const Attendance = () => {
  const navigate = useNavigate();
  const [currentWeek, setCurrentWeek] = useState(1);
  const [attendanceStatuses, setAttendanceStatuses] = useState({});
  
  // Attendance sessions - matching admin's data
  const attendanceSessions = [
    {
      id: 1,
      week: 1,
      title: 'Week 1 Attendance',
      formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSeKjcqNMyIEbppSjnsW3dEX4ZR0MHqR2gp0esowm3jIT0fOPA/viewform?usp=sharing&ouid=108026927187778950974',
      status: 'open'
    },
    {
      id: 2,
      week: 2,
      title: 'Week 2 Attendance',
      formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSeAAxaR6h3iYCk9Qrtqb3YO7o4tgynFRoyIhAk3OPlBsSBg0Q/viewform?usp=sharing&ouid=108026927187778950974',
      status: 'closed'
    },
    {
      id: 3,
      week: 3,
      title: 'Week 3 Attendance',
      formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScz9d2iKfLFdpMgrdXcqLKLojYId3kmMcczogDWy4SVmEJMYw/viewform?usp=publish-editor',
      status: 'closed'
    },
    {
      id: 4,
      week: 4,
      title: 'Week 4 Attendance',
      formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfeXZ3kbMei6DHbC2AgZJh1JZHCwJqG5hWyzVAP_5s6tGfjvA/viewform?usp=publish-editor',
      status: 'closed'
    },
    {
      id: 5,
      week: 5,
      title: 'Week 5 Attendance',
      formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSe4fsPEShb8_EOthpCo-Ylg5ygHVyKPnSL4puxCHOm29Y7Smg/viewform?usp=sharing&ouid=108026927187778950974',
      status: 'closed'
    },
    {
      id: 6,
      week: 6,
      title: 'Week 6 Attendance',
      formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSeAPnzzIvqj8Vhaw-e62etZl8ds0UruwRHL54CfH8VwCdrOZQ/viewform?usp=publish-editor',
      status: 'closed'
    },
    {
      id: 7,
      week: 7,
      title: 'Week 7 Attendance',
      formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfD_CkrlRo2ut2iNLGJePLTagVJ632NTaTrQGWmIlKmElJS5A/viewform?usp=publish-editor',
      status: 'closed'
    },
    {
      id: 8,
      week: 8,
      title: 'Week 8 Attendance',
      formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSd0zeOoZ3zKWN4eJHL1Ixbco3ch5HEcfOX235_yadQe66vaaQ/viewform?usp=publish-editor',
      status: 'closed'
    },
    {
      id: 9,
      week: 9,
      title: 'Week 9 Attendance',
      formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScLIxZK5Gr9Zqm3di5AR9wJWC69eja0A8CLzWMpMWBgzFYq9w/viewform?usp=publish-editor',
      status: 'closed'
    }
  ];

  // Load attendance statuses from Firestore
  useEffect(() => {
    const loadAttendanceStatuses = async () => {
      try {
        const instructorsRef = collection(db, 'instructors');
        const queryResult = await getDocs(instructorsRef);
        
        let allStatuses = {};
        for (const instructorDoc of queryResult.docs) {
          try {
            const statusCollectionRef = collection(db, 'instructors', instructorDoc.id, 'attendanceStatuses');
            const statusDocs = await getDocs(statusCollectionRef);
            
            for (const statusDoc of statusDocs.docs) {
              const statuses = statusDoc.data();
              // statuses contains attendance_1: 'open', attendance_2: 'closed', etc.
              Object.assign(allStatuses, statuses);
            }
          } catch (error) {
            console.log('Could not load attendance statuses for instructor:', instructorDoc.id);
          }
        }
        
        console.log('[Attendance] Loaded attendance statuses from Firestore:', allStatuses);
        setAttendanceStatuses(allStatuses);
      } catch (error) {
        console.error('Error loading attendance statuses:', error);
      }
    };
    
    loadAttendanceStatuses();
  }, []);

  // Get only open attendance sessions
  const openSessions = attendanceSessions.filter(session => attendanceStatuses[`attendance_${session.id}`] === 'open');
  
  // Get current attendance form
  const currentAttendance = attendanceSessions.find(a => a.week === currentWeek);
  const isOpen = currentAttendance && attendanceStatuses[`attendance_${currentAttendance.id}`] === 'open';

  // If no open sessions, show message
  if (openSessions.length === 0) {
    return (
      <div style={{ background: '#ffffff', minHeight: 'calc(100vh - 70px)', padding: '3rem 2rem' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ marginBottom: '3rem', display: 'flex', alignItems: 'center', gap: '1rem', paddingBottom: '1.5rem', borderBottom: '2px solid #e8e8e8' }}>
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                background: '#1a1a1a',
                border: 'none',
                color: 'white',
                padding: '0.6rem 0.8rem',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '1.1rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 300ms ease'
              }}
              onMouseOver={(e) => {
                e.target.style.background = '#2d2d2d';
                e.target.style.transform = 'scale(1.05)';
              }}
              onMouseOut={(e) => {
                e.target.style.background = '#1a1a1a';
                e.target.style.transform = 'scale(1)';
              }}
            >
              <i className="fas fa-arrow-left"></i>
            </button>
            <div>
              <h1 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1a1a1a', letterSpacing: '-1px', margin: '0' }}>
                <i className="fas fa-clipboard-list" style={{ marginRight: '1rem', color: '#1a1a1a' }}></i>
                Attendance
              </h1>
              <p style={{ fontSize: '1rem', color: '#666', margin: '0.5rem 0 0 0' }}>
                No open attendance forms at this moment. Check back later!
              </p>
            </div>
          </div>
          <div style={{ background: '#f9f9f9', border: '1px solid #e8e8e8', borderRadius: '8px', padding: '3rem', textAlign: 'center' }}>
            <p style={{ fontSize: '1.1rem', color: '#666', margin: 0 }}>
              All attendance forms are currently closed. Your instructor will open them when they're ready.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: '#ffffff', minHeight: 'calc(100vh - 70px)', padding: '3rem 2rem' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '3rem', display: 'flex', alignItems: 'center', gap: '1rem', paddingBottom: '1.5rem', borderBottom: '2px solid #e8e8e8' }}>
          <button
            onClick={() => navigate('/dashboard')}
            style={{
              background: '#1a1a1a',
              border: 'none',
              color: 'white',
              padding: '0.6rem 0.8rem',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '1.1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 300ms ease'
            }}
            onMouseOver={(e) => {
              e.target.style.background = '#2d2d2d';
              e.target.style.transform = 'scale(1.05)';
            }}
            onMouseOut={(e) => {
              e.target.style.background = '#1a1a1a';
              e.target.style.transform = 'scale(1)';
            }}
          >
            <i className="fas fa-arrow-left"></i>
          </button>
          <div>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1a1a1a', letterSpacing: '-1px', margin: '0' }}>
              <i className="fas fa-clipboard-list" style={{ marginRight: '1rem', color: '#1a1a1a' }}></i>
              Attendance
            </h1>
            <p style={{ fontSize: '1rem', color: '#666', margin: '0.5rem 0 0 0' }}>
              Fill out your weekly attendance below
            </p>
          </div>
        </div>

        {/* Open Sessions Info */}
        <div style={{ marginBottom: '2rem', padding: '1rem', background: '#e8f5e9', border: '1px solid #4caf50', borderRadius: '6px' }}>
          <p style={{ color: '#2e7d32', margin: 0, fontWeight: 600 }}>
            <i className="fas fa-check-circle" style={{ marginRight: '0.5rem' }}></i>
            {openSessions.length === 1 ? '1 attendance form is' : `${openSessions.length} attendance forms are`} currently open
          </p>
        </div>

        {/* Week Selector */}
        <div style={{ marginBottom: '2rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <label style={{ fontWeight: 600, color: '#1a1a1a', fontSize: '1rem' }}>Select Week:</label>
          <select 
            value={currentWeek} 
            onChange={(e) => setCurrentWeek(parseInt(e.target.value))}
            style={{
              padding: '0.75rem 1rem',
              border: '1px solid #e8e8e8',
              borderRadius: '6px',
              fontFamily: 'inherit',
              fontSize: '1rem',
              background: 'white',
              color: '#1a1a1a',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 300ms ease'
            }}
          >
            {attendanceSessions.map(session => (
              <option key={session.id} value={session.week}>
                Week {session.week} {attendanceStatuses[`attendance_${session.id}`] === 'open' ? '(Open)' : '(Closed)'}
              </option>
            ))}
          </select>
        </div>

        {/* Form Display */}
        {isOpen ? (
          <div style={{
            background: '#f9f9f9',
            border: '1px solid #e8e8e8',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
          }}>
            <div style={{ padding: '2rem', borderBottom: '1px solid #e8e8e8', background: '#ffffff' }}>
              <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#1a1a1a', margin: 0 }}>
                {currentAttendance.title}
              </h2>
              <p style={{ color: '#666', margin: '0.5rem 0 0 0', fontSize: '0.95rem' }}>
                Please fill out this form to mark your attendance for this week.
              </p>
            </div>
            <div style={{ padding: '2rem' }}>
              <iframe
                title={currentAttendance.title}
                src={currentAttendance.formUrl}
                width="100%"
                height="800"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                style={{ borderRadius: '6px' }}
              >
                Loading…
              </iframe>
            </div>
          </div>
        ) : (
          <div style={{ background: '#ffebee', border: '1px solid #ef5350', borderRadius: '8px', padding: '2rem', textAlign: 'center' }}>
            <p style={{ color: '#c62828', margin: 0, fontWeight: 600 }}>
              <i className="fas fa-lock" style={{ marginRight: '0.5rem' }}></i>
              The attendance form for Week {currentWeek} is currently closed. Please select an open week above.
            </p>
          </div>
        )}

        {/* Open Sessions List */}
        <div style={{ marginTop: '3rem' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '1.5rem', color: '#1a1a1a' }}>
            Available Attendance Forms
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1rem' }}>
            {openSessions.map(session => (
              <button
                key={session.id}
                onClick={() => setCurrentWeek(session.week)}
                style={{
                  padding: '1.5rem',
                  background: currentWeek === session.week ? '#1a1a1a' : '#f9f9f9',
                  color: currentWeek === session.week ? 'white' : '#1a1a1a',
                  border: `2px solid ${currentWeek === session.week ? '#1a1a1a' : '#e8e8e8'}`,
                  borderRadius: '6px',
                  cursor: 'pointer',
                  transition: 'all 300ms ease',
                  textAlign: 'center'
                }}
                onMouseOver={(e) => {
                  if (currentWeek !== session.week) {
                    e.currentTarget.style.borderColor = '#1a1a1a';
                    e.currentTarget.style.background = '#f0f0f0';
                  }
                }}
                onMouseOut={(e) => {
                  if (currentWeek !== session.week) {
                    e.currentTarget.style.borderColor = '#e8e8e8';
                    e.currentTarget.style.background = '#f9f9f9';
                  }
                }}
              >
                <h3 style={{ margin: '0 0 0.5rem 0', fontWeight: 700, fontSize: '1rem' }}>
                  Week {session.week}
                </h3>
                <p style={{ margin: 0, fontSize: '0.85rem', opacity: currentWeek === session.week ? 0.9 : 0.7 }}>
                  <i className="fas fa-check-circle"></i> Open
                </p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Attendance;
